// src/components/PayPalCheckoutButton.jsx
import React, { useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";

const PayPalCheckoutButton = ({ paymentDetails }) => {
    console.log("payyy",paymentDetails)
    //  const obj = {
    //   user_id: 1,
    //   course_id: 2,
    //   email_id: "saddam@gmail.com",
    //   amount: 12,
    //   payment_type: "full",
    //   currency: "USD",
    // };
  const paypalRef = useRef();
    let UserName=localStorage.getItem("uname")
    console.log("username",UserName)

    let paymentType=localStorage.getItem("payment_type")
        console.log("username",UserName)
    const navigate = useNavigate();

  useEffect(() => {
    // Load PayPal script dynamically
    const script = document.createElement("script");
    script.src = `https://www.paypal.com/sdk/js?client-id=AdCN1o9MzP7M-3DLsjLyLUEIOQZQtMPRk1dCIIImOpoj3wNuMkq3XEtd3ZUQ7hRQzh4sK8qlgQx8bmvO&currency=USD`;
    script.addEventListener("load", () => {
      window.paypal.Buttons({
        createOrder: async () => {
          // Call your backend to create the order
          const res = await fetch("https://api.rushividyabhyasam.org/api/payments/create_order", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(paymentDetails),
          });

          const data = await res.json();
          console.log("daaaaaa",data);
          localStorage.setItem("db_id",data?.id);

          return data.order; // Order ID created by your backend
        },
        onApprove: async (data, actions) => {
  try {
      let new_db=localStorage.getItem("db_id");
      let email_id=localStorage.getItem("email_id")
      localStorage.setItem("db_id",null);
    // Send the approved Order ID to your backend
    const res = await fetch("https://api.rushividyabhyasam.org/api/payments/paypal_payment_verify", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({id:new_db, order_id: data.orderID,user_name:UserName,payment_type:paymentType,email_id:email_id })
    });
    
 
    const captureData = await res.json();
    console.log("Order captured:", captureData.data[0]);
    const captured = captureData.data[0];

    if (captured) {
  localStorage.setItem("course_name_d", captured.course_name || "");
  localStorage.setItem("payment_id_d", captured.payment_id || "");
  localStorage.setItem("amount_d", captured.amount || "");
}
 
    if (captureData.data[0].status === "success") {
      alert("Payment successful!");
      localStorage.setItem("payment_getway_source","paypal");
      navigate("/paymentsuccess");
    } else {
      alert("Payment failed or pending.");
    }
  } catch (err) {
    console.error("Capture error:", err);
    alert("Payment capture failed.");
  }
},
        onError: (err) => {
          console.error("PayPal Checkout error:", err);
          alert("Something went wrong with the payment.");
        },
      }).render(paypalRef.current);
    });

    document.body.appendChild(script);
  }, [paymentDetails]);

  console.log("paypalRef",paypalRef, "process.env.PAYPAL_CLIENT_ID", process.env.PAYPAL_CLIENT_ID)

  return (
    <div>
      <div className='ttttt' style={{width:"200px",margin:"0 auto",marginTop:"20px"}} ref={paypalRef}></div>
    </div>
  );
};

export default PayPalCheckoutButton;
